import { Router, ActivationEnd, ActivatedRouteSnapshot, ActivationStart } from '@angular/router';
import { AARouterURL } from '../../enums/routing.enum';
import { AARouteEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';

export class AppRouterService extends EventsService {
  private snapshot: ActivatedRouteSnapshot;
  private activeRoute: AARouterURL;

  constructor(public router: Router) {
    super();
    this.router.events.subscribe( this.routerEventLitener );
  }

  get activeRouteTap(): AARouterURL {
    return this.activeRoute || AARouterURL.ROUTE_PLANNER;
  }

  private routerEventLitener = (event) => {
    this.snapshot = event.snapshot;

    if (event instanceof ActivationStart) {
      const queryParams = this.getQueryParams();
      this.activeRoute = queryParams.path;
      this.dispatch(AARouteEvents.ROUTE_READY, queryParams);
    }

    // if (event instanceof ActivationEnd ) {
    //   const queryParams = this.getQueryParams();
    // }
  }

  public getQueryParams(): any {
    const urlSegments = this.snapshot.url;

    if (urlSegments.length) {
      const path = {path: urlSegments[0].path};
      const queryParams = this.snapshot.queryParams;
      const params = this.snapshot.params;

      return {...path, ...queryParams, ...params};
    }

    return null;
  }
}
